import { InitialState, StoreLoadingEnum } from 'src/store/state/types';
import { IJobsMetrics } from './types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import metricsApi from './api';
import { RootState } from '../..';

/**
 * Initial State
 */

const initialState: InitialState<IJobsMetrics> = {
  loading: StoreLoadingEnum.idle,
  error: null,
  data: {
    succeeded: '',
    running: '',
    notStarted: '',
    failed: '',
    totalCount: '',
  },
};

/**
 * Async Actions
 */

export const fetchJobsMetrics = createAsyncThunk('metrics/fetch', async (options: {isRefresh?: boolean}) => {
  try {
    const response = await metricsApi.fetchJobsMetrics();
    return { data: { ...response.data, options } };
  } catch (e) {
    console.error(e);
  }
});

export const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobsMetrics.pending, (state, action) => {
        if (!action.meta.arg.isRefresh) {
          state.loading = StoreLoadingEnum.pending;
        }
      })
      .addCase(fetchJobsMetrics.fulfilled, (state, action) => {
        if (!action.meta.arg.isRefresh) {
          state.loading = StoreLoadingEnum.succeeded;
        }
        const { data } = action.payload!;
        state.data = data;
      })
      .addCase(fetchJobsMetrics.rejected, (state) => {
        state.loading = StoreLoadingEnum.failed;
      });
  },
});

export const metricsSelector = (state: RootState) => state.metrics.data;
export const isLoadingSelector = (state: RootState) =>
  state.metrics.loading === StoreLoadingEnum.pending;
